import React, { FunctionComponent } from 'react';
import type { CoverComponentProps, RecruitmentImage } from '../../../types/recruitments';
import { FavoriteBtn } from '../../atoms/favoriteBtn';
import classnames from 'classnames';

type Props = CoverComponentProps & {
  displayImages: RecruitmentImage[];
  currentIndex: number;
  handleSubImageClick: (index: number) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  noimage,
  hoverIcon,
  isPc,
  isCompany,
  recruitmentId,
  recruitmentData,
  dataClickPoint,
  dataListType,
  pageCategory,
  pageValue,
  handleSetSession,
  displayImages,
  currentIndex,
  handleSubImageClick,
  recruitmentNumber,
}) => {
  return (
    <>
      {/* メイン画像 */}
      <a
        onClick={handleSetSession}
        href={`/recruitments/${recruitmentData.id}`}
        className="article-card"
        data-event="click"
        data-category={pageCategory()}
        data-value={pageValue()}
        data-click-point={dataClickPoint.image}
        data-recruitmentid={recruitmentData.id}
        data-companyid={recruitmentData.company_id}
        data-state={recruitmentNumber}
        data-list-type={dataListType ?? 'normal'}
      >
        <div className={classnames('article__recruitment__card__gallery', { 'is-single': displayImages.length === 1 })}>
          <div className="article__recruitment__card__cover article__recruitment__card__cover--thumb">
            {/* スライドコンテナ */}
            <div className="article__recruitment__card__slider-viewport">
              <div
                className="article__recruitment__card__slider-track"
                style={{ transform: `translateX(-${currentIndex * 100}%)` }}
              >
                {displayImages.map((img, idx) => (
                  <img
                    key={img.id ?? idx}
                    src={img.url}
                    className="article__recruitment__card__cover--img"
                    alt={recruitmentData.recruitment_title + 'のカバー写真'}
                    loading={idx === 0 ? 'eager' : 'lazy'}
                    decoding="async"
                    width={640}
                    height={360}
                  />
                ))}
              </div>
            </div>
            {!isCompany && !recruitmentData.is_stopped && (
              <FavoriteBtn recruitmentId={String(recruitmentId)} dataListType={dataListType ?? 'normal'} />
            )}
            {isPc && (
              <div className="article-card-hover">
                <img src={hoverIcon} alt="" />
              </div>
            )}
            {recruitmentData.is_stopped && (
              <p className="article-card-container-stopped-attention">
                この募集は終了しました
              </p>
            )}
            {(recruitmentData.isScouted || recruitmentData.isApplied || recruitmentData.isNew || recruitmentData.regularEmployee) && (
              <div className="status_panel">
                {recruitmentData.isNew && <span className="is_tag">新着</span>}
                {recruitmentData.regularEmployee && <span className="is_tag">正社員</span>}
                {recruitmentData.isScouted && <span className="is_tag">スカウトあり</span>}
                {recruitmentData.isApplied && <span className="is_tag">エントリー済み</span>}
              </div>
            )}
          </div>
          {displayImages.length > 1 && (
            <div className={classnames(
              'article__recruitment__card__thumbs',
              'is-slider',
              { 'is-single': displayImages.length === 1 })}
            >
              {displayImages.map((img, idx) => (
                <button
                  key={img.id ?? idx}
                  type="button"
                  className="article__recruitment__card__thumb"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleSubImageClick(idx);
                  }}
                >
                  <img
                    src={img.url}
                    alt=""
                    loading="lazy"
                    decoding="async"
                    width={160}
                    height={90}
                  />
                </button>
              ))}
            </div>
          )}
        </div>
        <h2 className="article-card-heading article-card-heading--pc article__recruitment__card--title">
          {recruitmentData.recruitment_title}
        </h2>
      </a>
    </>
  );
};
